import { render, staticRenderFns } from "./ClientDashboardView.vue?vue&type=template&id=229a20fc&scoped=true"
import script from "./ClientDashboardView.vue?vue&type=script&lang=js"
export * from "./ClientDashboardView.vue?vue&type=script&lang=js"
import style0 from "./ClientDashboardView.vue?vue&type=style&index=0&id=229a20fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229a20fc",
  null
  
)

export default component.exports